import { render } from "./ProductBackup.vue?vue&type=template&id=14d6aadc&scoped=true"
import script from "./ProductBackup.vue?vue&type=script&lang=js"
export * from "./ProductBackup.vue?vue&type=script&lang=js"

import "./ProductBackup.vue?vue&type=style&index=0&id=14d6aadc&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d6aadc"]])

export default __exports__